export const statuses = {
    'unreviewed' : 'Unreviewed',
    'in_progress' : 'In Progress',
    'completed' : 'Completed'
}
